'use strict';

const Recommendations = require('bunsen/collections/identity/Recommendations');
const User = require('../models/User');
const {ACTIONS, STORE} = require('../constants/recommendationsConstants');

const recommendationsActions = {

    fetch(actionContext, payload, done) {
        const {
            collection = new Recommendations(),
            categoryLevels,
            categoryKeys,
            collectionKey,
            pageSize = 1,
            namedQuery,
            attributes,
            type,
            query,
            orderBy
        } = payload;

        collection
            .setParam('recommendationType', type)
            .setParam('categoryLevels', categoryLevels)
            .setParam('categoryKeys', categoryKeys)
            .setParam('namedQuery', namedQuery)
            .setParam('userIds', User.getUserId())
            .setParam('attributes', attributes)
            .setParam('query', query)
            .setParam('pageSize', pageSize)
            .setParam('orderBy', orderBy);

        return Promise.resolve(collection.fetchWithParameters())
            .then(() => {
                actionContext.dispatch(STORE.FETCH_SUCCESS, {collectionKey, collection});
                done();
            })
            .catch(() => {
                actionContext.dispatch(STORE.FETCH_SUCCESS);
                done();
            });
    },

    fetchByCategory(actionContext, payload, done) {
        const {
            categoryLevels = 3,
            itemsPageSize = 30,
            collectionKey,
            collection,
            pageSize,
            fields
        } = payload;

        const fieldsQuery = fields ? `&fields=${fields}` : '';

        return actionContext.executeAction(recommendationsActions.fetch, {
            collection,
            collectionKey,
            type: ACTIONS.TYPE.CATEGORY,
            categoryLevels,
            pageSize,
            query: `pageSize=${itemsPageSize}${fieldsQuery}&filterQuery=category_search:1,hideprice:N,vertical:{vertical},l2_url_label:{l2_url_label},l3_url_label:{l3_url_label},l4_url_label:{l4_url_label}&sort=releasedate desc,sort_cs_status asc,priority asc`
        }).then(() => done());
    },

    fetchByAttribute(actionContext, payload, done) {
        const {
            categoryLevels = 3,
            itemsPageSize = 30,
            pageSize,
            collectionKey,
            attributes,
            collection,
            categoryKeys,
            fields = '',
            orderBy = 'TYPE_RANK'
        } = payload;

        const fieldsQuery = fields ? `&fields=${fields}` : '';

        return actionContext.executeAction(recommendationsActions.fetch, {
            collection,
            collectionKey,
            type: ACTIONS.TYPE.ATTRIBUTE,
            attributes,
            pageSize,
            categoryKeys,
            categoryLevels,
            orderBy,
            query: `pageSize=${itemsPageSize}${fieldsQuery}&filterQuery=category_search:1,hideprice:N,vertical:{vertical},l2_url_label:{l2_url_label},l3_url_label:{l3_url_label},l4_url_label:{l4_url_label},attr_opt_url_label_{attribute_solr_field_suffix}:{attribute_option_url_label}&sort=releasedate desc,sort_cs_status asc,priority asc`
        }).then(() => done());
    }
};

module.exports = recommendationsActions;



// WEBPACK FOOTER //
// ./assets/js/global/actions/recommendationsActions.es.js